import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { LightboxOverlay, LightboxContent, LightboxClose, LightboxNav } from './Styled';

const TestimonialLightbox = ({ images, activeIndex, onClose, onNavigate }) => {
    const { i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';

    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Escape') onClose();
        if (e.key === 'ArrowLeft') onNavigate(isRTL ? 1 : -1);
        if (e.key === 'ArrowRight') onNavigate(isRTL ? -1 : 1);
    }, [onClose, onNavigate, isRTL]);

    useEffect(() => {
        if (activeIndex === null) return;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.body.style.overflow = '';
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [activeIndex, handleKeyDown]);

    if (activeIndex === null) return null;

    const current = images[activeIndex];

    return (
        <LightboxOverlay onClick={onClose}>
            <LightboxClose onClick={onClose} aria-label="Close">&times;</LightboxClose>
            <LightboxNav
                className="prev"
                onClick={(e) => { e.stopPropagation(); onNavigate(-1); }}
                aria-label="Previous"
            >
                {isRTL ? '\u203A' : '\u2039'}
            </LightboxNav>
            <LightboxContent onClick={(e) => e.stopPropagation()}>
                <img src={current.src} alt={current.alt} />
            </LightboxContent>
            <LightboxNav
                className="next"
                onClick={(e) => { e.stopPropagation(); onNavigate(1); }}
                aria-label="Next"
            >
                {isRTL ? '\u2039' : '\u203A'}
            </LightboxNav>
        </LightboxOverlay>
    );
};

export default TestimonialLightbox;
